import { render, staticRenderFns } from "./EventoAbonados.vue?vue&type=template&id=5483b985"
import script from "./EventoAbonados.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoAbonados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports